export default {
  layersTree: [],
  temporalLayers: [],
  permaLayers: null,
  permaLabels: null,
  permaProfile: null,
  infoLayerTree: null,
  layersLoaded: 0,
  mapScope: {

  },
  currentEditor: null,
  currentInfoItem: null,
  infoToolLine: null,
  constraintPhotosId: null,
  filterInfoKey: null,
  renderedLabelsMap: {},
  layerFiltersMap: {},
  widgetResizeMap: {},
  designotron: {
    enabled: false
  },
  logitron: {
    enabled: false
  },
  commentState: false,
  initialised: false,
  linkShow: false,
  searchShow: false,
  profileShow: false,
  temporalShow: false,
  printMode: false,
  potreeLoaded: false,
  printProfile: 0,
  currentCommentIssue: null,
  commentIssues: null,
  mapSize: null,
  activatedLegends: [],
  showReleaseNotes: false,
  showTour: false,
  loadingTiles: 1,
  layersSorted: 0,
  qeuedLayers: 0,
  scopeAOI: null,
  scopeState: 'whole',
  hideAllWidgets: false,
  context_coords: [],
  context_centreline: null,
  context_elevation: null,
  flow_uls_tables: '',
  flow_mode: 'gas',
  angle3d: 0,
  camera3dPotistion: null,
  view3dtiles: [],
  loadingFlowInteraction: false,
  phaseOptions: [],
  profileMode: 'flowline',
  currentMapCenter: []
}



// WEBPACK FOOTER //
// ./src/store/modules/map/state.js